import {Offcanvas} from 'react-bootstrap'
import {FormattedMessage} from 'react-intl'
import {OneAddQuotePage} from '../../oneAddQuote/OneAddQuotePage'
import {IForm} from '../../oneAddQuote/oneQuoteTypes'

interface SelectPlansDrawerProps {
  isOpen: boolean
  onClose: () => void
  quoteData: IForm
  onSelectPlan: (plan: any) => void
}

export const SelectPlansDrawer: React.FC<SelectPlansDrawerProps> = ({
  isOpen,
  onClose,
  quoteData,
  onSelectPlan,
}) => {
  return (
    <Offcanvas show={isOpen} onHide={onClose} placement='end' style={{width: '85vw'}}>
      <Offcanvas.Header closeButton className='bg-light'>
        <Offcanvas.Title className='d-flex align-items-center gap-4'>
          <FormattedMessage id='policies.detail.modal.plans.title' defaultMessage='Search Plans' />
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <OneAddQuotePage quoteData={quoteData} onSelectPlan={onSelectPlan} />
      </Offcanvas.Body>
    </Offcanvas>
  )
}
